import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { TruckOwnerRoutingModule } from "./truck-owner-routing.module";
import { TrucksComponent } from "./trucks/trucks.component";
import { TruckSidebarComponent } from "./truck-sidebar/truck-sidebar.component";
import { DriversComponent } from "./drivers/drivers.component";
import { MappingComponent } from "./mapping/mapping.component";
import { DriverOrdersComponent } from "./driver-orders/driver-orders.component";
import { ViewDriverRouteComponent } from "./view-driver-route/view-driver-route.component";
import { CreateDriverRouteComponent } from "./create-driver-route/create-driver-route.component";
import { OrdersComponent } from "./orders/orders.component";

import { PaymentsComponent } from "./payments/payments.component";
import { TrackComponent } from "./track/track.component";
import { TransporterLoginComponent } from "./transporter-login/transporter-login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material/material-module";
import { TrucksViewComponent } from "./trucks-view/trucks-view.component";
import { DriverViewComponent } from "./driver-view/driver-view.component";
import { OrdersTripViewComponent } from "./orders-trip-view/orders-trip-view.component";
import { TrucksAddComponent } from "./trucks-add/trucks-add.component";
import { DriverAddComponent } from "./driver-add/driver-add.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { TruckownerProfileComponent } from "./truckowner-profile/truckowner-profile.component";
import { DeliveryOrdersComponent } from "./delivery-orders/delivery-orders.component";
import { AddCreditTripComponent } from "./add-credit-trip/add-credit-trip.component";
import { ReportsComponent } from "./reports/reports.component";
import { EditCreditTripComponent } from "./edit-credit-trip/edit-credit-trip.component";
import { ProfileComponent } from "./profile/profile.component";
import { DeleteAccountComponent } from "./delete-account/delete-account.component";
import { TruckownerTripCancelComponent } from "./truckowner-trip-cancel/truckowner-trip-cancel.component";
import { UpperCaseInputDirective } from "./Uppercase-truckOwner.directive";
import { AlphanumericOnlyDirective } from "./alphaNumeric-truckOwner.directive";
import { TwoDigitDecimaNumberDirective } from "./twoDigit-truckOwner.directive";
import { DisableInputDirective } from "./disabled-input.directive";
import { CustomDateAdapter } from "./custome-directives";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { ThreeDigitDecimalNumberDirective } from "./threeDigit-decimal-Number-TruckOwner.directive";
import { PreOrdersComponent } from './pre-orders/pre-orders.component';
import { PreOrderAddTruckComponent } from './pre-order-add-truck/pre-order-add-truck.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { PreorderSettingsComponent } from './preorder-settings/preorder-settings.component';
import { AddRoutesComponent } from './add-routes/add-routes.component';
import { PreOrderBidRateComponent } from './pre-order-bid-rate/pre-order-bid-rate.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { NotificationsComponent } from './notifications/notifications.component';
import { QuoteBidComponent } from './quote-bid/quote-bid.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "dd-MM-yyyy",
  },
  display: {
    dateInput: "dd-MM-yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@NgModule({
  declarations: [
    TrucksComponent,
    TruckSidebarComponent,
    DriversComponent,
    MappingComponent,
    DriverOrdersComponent,
    ViewDriverRouteComponent,
    CreateDriverRouteComponent,
    OrdersComponent,
    PaymentsComponent,
    TrackComponent,
    TrucksViewComponent,
    DriverViewComponent,
    OrdersTripViewComponent,
    TrucksAddComponent,
    TransporterLoginComponent,
    DriverAddComponent,
    TruckownerProfileComponent,
    DeliveryOrdersComponent,
    AddCreditTripComponent,
    ReportsComponent,
    EditCreditTripComponent,
    ProfileComponent,
    DeleteAccountComponent,
    TruckownerTripCancelComponent,
    UpperCaseInputDirective,
    AlphanumericOnlyDirective,
    TwoDigitDecimaNumberDirective,
    ThreeDigitDecimalNumberDirective,
    DisableInputDirective,
    PreOrdersComponent,
    PreOrderAddTruckComponent,
    DeleteDialogComponent,
    PreorderSettingsComponent,
    AddRoutesComponent,
    PreOrderBidRateComponent,
    NotificationsComponent,
    QuoteBidComponent,
  ],
  imports: [
    CommonModule,
    TruckOwnerRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    GoogleMapsModule,
    MatProgressSpinnerModule,
    MatButtonModule
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
})
export class TruckOwnerModule {}
